import * as Icons from "lucide-react";
import { FEATURES } from "../../lib/constants";

export default function Features() {
  return (
    <section id="diferenciadores" data-testid="features-section" className="bg-navy-600 text-white section-pad relative overflow-hidden">
      <div className="absolute -top-24 -right-24 w-80 h-80 bg-accent/10 blur-3xl rounded-full pointer-events-none" />
      <div className="container-tight relative">
        <div className="flex items-center gap-3 mb-4">
          <span className="divider-accent" />
          <span className="kicker-bright">Diferenciadores</span>
        </div>
        <h2 className="font-display font-black tracking-tightest text-4xl md:text-5xl lg:text-6xl max-w-4xl">
          Por qué elegir <span className="text-accent">Velarias Tens</span>.
        </h2>
        <p className="mt-6 max-w-2xl text-white/70 text-base md:text-lg">
          Más de 20 años de experiencia, ingeniería certificada y materiales premium.
        </p>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10">
          {FEATURES.map((f, i) => {
            const Icon = Icons[f.icon] || Icons.Star;
            return (
              <div
                key={i}
                className="bg-navy-600 p-8 md:p-10 hover-lift group"
                data-testid={`feature-${i}`}
              >
                <div className="w-14 h-14 grid place-items-center border border-accent/40 text-accent group-hover:bg-accent group-hover:text-white transition-colors">
                  <Icon className="w-7 h-7" />
                </div>
                <h3 className="mt-6 font-display font-black text-xl md:text-2xl tracking-tight">
                  {f.title}
                </h3>
                <p className="mt-3 text-white/70 leading-relaxed text-sm md:text-base">
                  {f.desc}
                </p>
              </div>
            );
          })}
        </div>

        {/* Post-Features banner CTA — Videollamada técnica */}
        <div
          className="mt-16 border border-accent/40 bg-eclipse/50 p-8 md:p-10 flex flex-col md:flex-row md:items-center justify-between gap-6"
          data-testid="features-video-cta"
        >
          <div>
            <span className="kicker-bright">Asesoría técnica · Sin costo</span>
            <h3 className="mt-3 font-display font-black text-2xl md:text-3xl text-white tracking-tight">
              Agenda una videollamada técnica <span className="text-accent">gratis de 20 min</span>
            </h3>
            <p className="mt-3 text-white/70 max-w-xl">
              Un ingeniero revisa tu espacio por video y te da un plan preliminar. Sin compromiso.
            </p>
          </div>
          <button
            type="button"
            onClick={() => {
              window.dispatchEvent(new CustomEvent("vt:prefillQuote", { detail: { typeKey: "otro" } }));
              const el = document.getElementById("cotiza");
              if (el) el.scrollIntoView({ behavior: "smooth" });
            }}
            className="btn-accent flex-shrink-0"
            data-testid="features-video-cta-btn"
          >
            Agendar videollamada
          </button>
        </div>
      </div>
    </section>
  );
}
